import { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { trySync } from '../../services/offline/syncQueue';
import { trySyncFertilizantes } from '../../services/offline/syncQueueFertilizantes';
import { subscribeNetworkStatus } from '../../services/offline/networkStatus';

// Componente headless (sin UI propia) que dispara la sincronización de las
// colas offline en los 3 momentos "automáticos" pedidos, además de los
// botones manuales (que viven en cada listado): evento online, apertura de
// la app (mount) y vuelta a foreground (visibilitychange) — no se depende
// exclusivamente de Background Sync, poco fiable en iOS/Safari.
//
// Dispara ambas colas (Aplicaciones y Fertilizantes) desde el mismo punto de
// entrada: son colas/stores independientes, nunca se mezclan sus datos.
//
// Solo corre para ENCARGADO activo con productor activo: ADMIN no tiene
// módulo offline.
function OfflineSyncManager() {
  const { user, encargado, productor, isAdmin } = useAuth();
  const authUserId = user?.id;
  const canSync = !isAdmin && Boolean(authUserId && encargado?.activo && productor?.activo);

  useEffect(() => {
    if (!canSync) return undefined;

    trySync(authUserId);
    trySyncFertilizantes(authUserId);

    const unsubscribe = subscribeNetworkStatus((online) => {
      if (online) {
        trySync(authUserId);
        trySyncFertilizantes(authUserId);
      }
    });

    function handleVisibility() {
      if (document.visibilityState === 'visible') {
        trySync(authUserId);
        trySyncFertilizantes(authUserId);
      }
    }
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      unsubscribe();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [canSync, authUserId]);

  return null;
}

export default OfflineSyncManager;
